import { render, staticRenderFns } from "./MyTaxis.vue?vue&type=template&id=631cf1e3&scoped=true"
import script from "./MyTaxis.vue?vue&type=script&lang=js"
export * from "./MyTaxis.vue?vue&type=script&lang=js"
import style0 from "./MyTaxis.vue?vue&type=style&index=0&id=631cf1e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cf1e3",
  null
  
)

export default component.exports